const nameValidation = (value) => {
  let error;
  if (!value) {
    error = "validation.project_name_required";
  }
  return error;
};
const startValidation = (value) => {
  let error;
  if (!value) {
    error = "validation.project_start_required";
  }
  return error;
};
const polygonValidation = (value) => {
  let error;
  if (!value) {
    error = "validation.area_required";
  }
  return error;
};

export const validation = {
  nameValidation,
  polygonValidation,
  startValidation,
};
